module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.access-schemes')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "access-schemes",
      "columns": ['name'],
      "s-model": "access-scheme"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fbef995!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access-scheme/AccessSchemeList.vue
// module id = 1147
// module chunks = 2